(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
function corslite(url, callback, cors) {
    var sent = false;

    if (typeof window.XMLHttpRequest === 'undefined') {
        return callback(Error('Browser not supported'));
    }

    if (typeof cors === 'undefined') {
        var m = url.match(/^\s*https?:\/\/[^\/]*/);
        cors = m && (m[0] !== location.protocol + '//' + location.domain +
                (location.port ? ':' + location.port : ''));
    }

    var x = new window.XMLHttpRequest();

    function isSuccessful(status) {
        return status >= 200 && status < 300 || status === 304;
    }

    if (cors && !('withCredentials' in x)) {
        // IE8-9
        x = new window.XDomainRequest();

        // Ensure callback is never called synchronously, i.e., before
        // x.send() returns (this has been observed in the wild).
        // See https://github.com/mapbox/mapbox.js/issues/472
        var original = callback;
        callback = function() {
            if (sent) {
                original.apply(this, arguments);
            } else {
                var that = this, args = arguments;
                setTimeout(function() {
                    original.apply(that, args);
                }, 0);
            }
        }
    }

    function loaded() {
        if (
            // XDomainRequest
            x.status === undefined ||
            // modern browsers
            isSuccessful(x.status)) callback.call(x, null, x);
        else callback.call(x, x, null);
    }

    // Both `onreadystatechange` and `onload` can fire. `onreadystatechange`
    // has [been supported for longer](http://stackoverflow.com/a/9181508/229001).
    if ('onload' in x) {
        x.onload = loaded;
    } else {
        x.onreadystatechange = function readystate() {
            if (x.readyState === 4) {
                loaded();
            }
        };
    }

    // Call the callback with the XMLHttpRequest object as an error and prevent
    // it from ever being called again by reassigning it to `noop`
    x.onerror = function error(evt) {
        // XDomainRequest provides no evt parameter
        callback.call(this, evt || true, null);
        callback = function() { };
    };

    // IE9 must have onprogress be set to a unique function.
    x.onprogress = function() { };

    x.ontimeout = function(evt) {
        callback.call(this, evt, null);
        callback = function() { };
    };

    x.onabort = function(evt) {
        callback.call(this, evt, null);
        callback = function() { };
    };

    // GET is the only supported HTTP Verb by XDomainRequest and is the
    // only one supported here.
    x.open('GET', url, true);

    // Send the request. Sending data is not supported.
    x.send(null);
    sent = true;

    return x;
}

if (typeof module !== 'undefined') module.exports = corslite;

},{}],3:[function(require,module,exports){
(function (global){
(function() {
	'use strict';

	var L = (typeof window !== "undefined" ? window.L : typeof global !== "undefined" ? global.L : null);
	var corslite = require('corslite');

	L.Routing = L.Routing || {};

	L.Routing.Myrouter = L.Evented.extend({
		options: {
			//serviceUrl: 'http://localhost:8989/trroute',
			serviceUrl: '/ors/experimentalroutes',
			timeout: 30 * 1000,
			urlParameters: {}
		},

		initialize: function(apiKey, options) {
			this._apiKey = apiKey;
			L.Util.setOptions(this, options);
		},

		route: function(waypoints, callback, context, options) {
			//console.log(options);
			var timedOut = false,
				wps = [],
				url,
				timer,
				wp,
				i;

			var forceDirect = control.getPlan().appliedLocationHash;
			options = options || {};
			// A restored URL supplies its own effective parameters; a previously
			// selected route must not override them.
			url = this.buildRouteUrl(waypoints, options,
				control.getPlan()._restoringLocationHash ? null : context._selectedRoute, forceDirect);

			if (forceDirect) {
				control.getPlan().appliedLocationHash = false;
			}

			timer = setTimeout(function() {
								timedOut = true;
								callback.call(context || callback, {
									status: -1,
									message: 'GraphHopper request timed out.'
								});
							}, this.options.timeout);

			// Create a copy of the waypoints, since they
			// might otherwise be asynchronously modified while
			// the request is being processed.
			for (i = 0; i < waypoints.length; i++) {
				wp = waypoints[i];
				wps.push({
					latLng: wp.latLng,
					name: wp.name,
					options: wp.options
				});
			}

			corslite(url, L.bind(function(err, resp) {
				var data;

				clearTimeout(timer);
				if (!timedOut) {
					var fired = err ? err : resp;
					if (!err) {
						data = JSON.parse(resp.responseText);
						this._routeDone(data, wps, callback, context, options);
					} else {
						var finalResponse;
						var responseText = err && err.responseText;
						try {
							finalResponse = JSON.parse(responseText);
						} catch (e) {
							finalResponse = responseText;
						}

						callback.call(context || callback, {
							status: -1,
							message: 'HTTP request failed: ' + err,
							response: finalResponse
						});
					}
				}
			}, this));

			return this;
		},

		_routeDone: function(response, inputWaypoints, callback, context, inputOptions) {
			var alts = [],
			    mappedWaypoints,
			    coordinates,
			    i,
			    path;

			context = context || callback;
			if (response.error && response.error.message) {
				callback.call(context, {
					// TODO: include all errors
					status: response.error.code,
					message: response.error.message
				});
				return;
			}

			for (i = 0; i < response.routes.length; i++) {
				path = response.routes[i];
				coordinates = this._decodePolyline(path.geometry.coordinates);
				//mappedWaypoints = response.routes[i].waypointIndices;

				alts.push({
					name: (path.distance/1000).toFixed(1) + L.localisation.get('search.kmRoute'),
					resolveName: this._getRouteName,
					candidateOsmName: path.candidateOsmName,
					geometry: path.geometry,
					coordinates: coordinates,
					instructions: [], /*this._convertInstructions(path.instructions),*/
					summary: {
						totalDistance: path.distance,
						totalTime: 0, //path.time / 1000,
						totalAscend: path.ascent,
						totalDescend: path.descent,
						wayTypes: path.wayTypes
					},
					inputWaypoints: inputWaypoints,
					// has the backend generated new waypoints because of a target distance?
					// if so, adopt them, if not, keep out existing ones.
					// we want to keep the existing ones beause they may have straight line metadata
					actualWaypoints: inputOptions.targetDistance == 0 && inputWaypoints.length == path.waypoints.length ?
                                                            inputWaypoints : this._toWaypoints(inputWaypoints, this._decodePolyline(path.waypoints)),
					waypointIndices: path.waypointIndices,
					overriddenParameters: path.overriddenParameters,
					inputOptions: inputOptions
				});
			}

			callback.call(context, null, alts);
		},

		/* Hacky: This is intended to be called in the UI after the waypoints have been geocoded. But there's no guarantee */
		/* Note: `this` in this function refers to the route, see alts.push above */
		_getRouteName: function() {
			var waypoints = control.getWaypoints();
			var dist = control.getPlan().getImperialUnits() ?
					(this.summary.totalDistance/1609.344).toFixed(1) + 'mi' :
					(this.summary.totalDistance/1000).toFixed(1) + 'km';
			if (this.inputOptions.roundTrip) {
				if (control.getWaypoints()[0].name) {
					return control.getWaypoints()[0].name.replace(/,.*/,'') + 
					  ', round-trip for '+dist;
				} else {
					return 'Round trip route for '+dist;
				}
			} else {
				if (control.getWaypoints()[0].name &&
				    control.getWaypoints()[ control.getWaypoints().length - 1 ].name) {
					return control.getWaypoints()[0].name.replace(/,.*/,'') + ' to ' +
	 				  control.getWaypoints()[ control.getWaypoints().length - 1 ].name.replace(/,.*/,'') + ', '+dist;
				} else {
					return 'Point-to-point route, for '+dist;
				}
			}
		},

		_decodePolyline: function(geometry) {
			var latlngs = new Array(geometry.length),
				i;
			for (i = 0; i < geometry.length; i++) {
				latlngs[i] = new L.LatLng(geometry[i][1], geometry[i][0]);
			}

			return latlngs;
		},

		_toWaypoints: function(inputWaypoints, vias) {
			var wps = [],
			    i;
			for (i = 0; i < vias.length; i++) {
				wps.push({
					latLng: L.latLng(vias[i]),
					name: inputWaypoints.length > i ? inputWaypoints[i].name : null,
					options: inputWaypoints.length > i ? inputWaypoints[i].options : {}
				});
			}

			return wps;
		},

		buildRouteUrl: function(waypoints, options, existingRoute, forceDirect) {
			var computeInstructions =
				/* Instructions are always needed, 
				   since we do not have waypoint indices otherwise */
				true,
				//!(options && options.geometryOnly),
				locs = [],
				skipSegments = [],
				i,
				baseUrl;

			var objcopy = function(src, dst) {
				for(var k in dst) {
					src[k] = dst[k];
				}
 			}

			var newOptions = {};
			objcopy(newOptions, this.options);
			objcopy(newOptions, options);
			options = newOptions;

/*
			// If we're editing an existing route, then force
			// targetDistance=0 and roundTrip=false. This prevents us from redrawing a new RT
			// route, as the user really wants to edit an existing one.
			var editExistingRoute = false;
			if (existingRoute && existingRoute.inputOptions.targetDistance > 0 && existingRoute.inputOptions.roundTrip == options.roundTrip) {

				// If the first WP has changed, then obviously we're changing the whole route
				if (options.roundTrip &&
					!waypoints[0].latLng.equals(existingRoute.inputWaypoints[0].latLng,0.0001)) {
					editExistingRoute = false;
				// If there's only WP then we can't be editing an existing route
				} else if (options.roundTrip && waypoints.length == 1) {
					editExistingRoute = false;
				// If the first WP is the same, but others are different then obviously we are editing a route
				} else if (waypoints.length != existingRoute.actualWaypoints.length)	{
					editExistingRoute = true;
				} else {
					// If the WP count is the same, then they could still have dragged a point
					var allPointsEqual = true;
					for(var i=1; i<waypoints.length; i++) {
						var existingStraight = existingRoute.inputWaypoints.length >= i+1 && existingRoute.inputWaypoints[i].options.straightLines;
						if (!waypoints[i].latLng.equals(existingRoute.actualWaypoints[i].latLng,0.0001) ||
						    waypoints[i].options.straightLines != existingStraight) {
							allPointsEqual = false;
							break;
						}
					}
					// If some points have changed and the target distance is the same, then they are
					// editing the list of points
					if (!allPointsEqual && options.targetDistance == existingRoute.inputOptions.targetDistance)
						editExistingRoute = true;
				}

				if (options.targetDistance == 0 && waypoints.length > 2) {
					waypoints = [ waypoints[0], waypoints[waypoints.length-1] ];
				}
			}

			if (editExistingRoute || forceDirect) {
				options = L.extend(options, { targetDistance: 0, roundTrip: false });
			}
*/

			// An override belongs to the selected route, not to the user's settings.
			// Only reuse it when reconstructing that route as a direct route (for
			// example, when exporting it). New route requests must use the current
			// value from the plan.
			if (forceDirect && existingRoute && existingRoute.overriddenParameters && typeof(existingRoute.overriddenParameters.avoidRepetition) !== 'undefined') {
				options.avoidRepetition = existingRoute.overriddenParameters.avoidRepetition;
			}

			if (forceDirect) {
				options = L.extend(options, { targetDistance: 0, roundTrip: false });
			}

			if (options.targetDistance > 0 && waypoints.length > 2) {
				waypoints = [ waypoints[0], waypoints[waypoints.length-1] ];
			}

			for (i = 0; i < waypoints.length; i++) {
				locs.push(waypoints[i].latLng.lng.toFixed(5) + ',' + waypoints[i].latLng.lat.toFixed(5));
				if (waypoints[i].options.straightLines) {
					skipSegments.push(i);
				}
			}

			baseUrl = this.options.serviceUrl + '?' +
				'coordinates=' + locs.join('%7C') + '&' +
				'skip_segments=' + skipSegments.join(',');

			return baseUrl +
				'&green_preference=' + options.greenPreference +
				'&avoid_unsafe_streets=' + options.avoidUnsafeStreets +
				'&avoid_unlit_streets=' + options.avoidUnlitStreets +
                                '&hills_preference=' + options.hillPreference +
                                '&avoid_repetition=' + options.avoidRepetition +
				'&target_distance=' + options.targetDistance +
				'&roundtrip=' + options.roundTrip;
		}

	});

	L.Routing.myrouter = function(apiKey, options) {
		return new L.Routing.Myrouter(apiKey, options);
	};

	module.exports = L.Routing.Myrouter;
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"corslite":1}]},{},[3]);
